// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// Import Pages
import { Checkboxes } from '../../FlowConfigurationInputs';
import VariablePicker from '../../FlowConfigurationInputs/VariablePicker/VariablePicker';

// Import CSS
import './EventConfiguration.css';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       value - string
 * @Param       children - components
 * @Param       onChange - function
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function EventConfiguration({ action, setField, variables, setOpenVariable }) {
    const { t, i18n } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EVENT-CONFIGURATION.';
    const options = {
        checkboxes: { label: label + 'CATCH-ERROR' }
    }
    const initial = {
        errorReaction: { value: 'no' },
        numberOfRetries: { value: 1 },
        retryDuration: { value: 5000 }
    }
    const [state, setState] = useState(initial);
    const [errorCatching, setErrorCatching] = useState();

    useEffect(() => {
        if (action.item_id) {
            if (action.fields.errorCatching?.value) {
                setErrorCatching(true);
            } else {
                setErrorCatching(false);
                delete action.fields.errorObject;
            }
        }
    }, [action.item_id]);

    // useEffect(() => {
    //     if (action.item_id) {
    //         if (!errorCatching && action.fields.errorObject) {
    //             console.log('errorObject aldıııı')
    //             delete action.fields.errorObject;
    //         }
    //     }
    // }, [errorCatching]);

    useEffect(() => {
        const init = (a) => {
            if (action.fields[a]) { state[a] = action.fields[a]; }
            else { action.fields[a] = initial[a]; state[a] = initial[a]; if (setField) { setField(a, initial[a]) } }
        };
        const fields = ['errorReaction', 'numberOfRetries', 'retryDuration'];
        for (const i of fields) { init(i); }
        setState({ ...state });
    }, [action]);

    const handleChange = (e, name) => {
        if (name === 'switch') {
            if (e.target.checked) {
                action.fields.errorReaction = { value: 'continue' };
                state.errorReaction = { value: 'continue' };
            } else {
                action.fields.errorReaction = { value: 'no' };
                state.errorReaction = { value: 'no' };
            }
            if (setField) {
                setField("errorReaction", action.fields.errorReaction)
            }
        } else {
            const value = e.target.value;
            action.fields[name] = { value };
            state[name] = { value };
            if (setField) {
                setField(name, action.fields[name])
            }

            if (value === 'retry') {
                setErrorCatching(false);
                delete action.fields.errorCatching
                delete action.fields.errorObject;
            }
        }
        setState({ ...state });

    };

    const changeOnCatching = (v) => {
        if (!v.value) {
            delete action.fields.errorObject;
        }
        setErrorCatching(v.value);
        
    }

    return (
        <>
            <div className="event-conf-header">
                <div>{t(label + 'HEADER')}</div>
                <label className="switch small">
                    <input
                        type="checkbox" checked={state.errorReaction.value !== 'no'}
                        onChange={(e) => { handleChange(e, 'switch'); }}
                    />
                    <span className="slider round red" />
                </label>
            </div>
            {state.errorReaction.value !== 'no' &&
                <RadioGroup value={state.errorReaction.value}
                    onChange={(e) => { handleChange(e, 'errorReaction'); }}>
                    <div className="field-form-section margin-top-8">
                        <FormControlLabel
                            value="continue" label={i18n.language === 'tr-TR' ?
                                <span><span className="event-error">HATA</span> oluşursa Akışa Devam <span className="default">{t(label + 'DEFAULT')}</span></span> :
                                <span>Continue Flow if <span className="event-error">ERROR</span> occurs<span className="default">{t(label + 'DEFAULT')}</span></span>
                            }
                            control={<Radio color="default" size="small" />}
                        />
                        {
                            state.errorReaction.value === 'continue' &&
                            <>
                                < div className="form-element">
                                    <Checkboxes onChange={changeOnCatching} action={action} inputName="errorCatching" options={options.checkboxes} style={{ fontSize: "12px", fontWeight: 600, color: '#202034' }} />
                                </div>
                                {
                                    errorCatching &&
                                    <div className="form-element">
                                        {t(label + 'ASSIGN-ERROR-TO-VARIABLE')}
                                        <VariablePicker action={action} inputName="errorObject" variables={variables} setOpenVariable={setOpenVariable} filter="object" isRequired />
                                        <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'object' })}</em></small>
                                        <div className='margin-top-8'>
                                            <small><em>{t(label + 'ASSIGN-ERROR-DESCRIPTION')}</em></small>
                                        </div>

                                    </div>
                                }

                            </>
                        }
                    </div>
                    <div className="field-form-section margin-top-8" >
                        <FormControlLabel
                            value="retry" label={i18n.language === 'tr-TR' ?
                                <span><span className="event-error">HATA</span> oluşursa Eylemi Yeniden Dene</span> :
                                <span>Retry Action if <span className="event-error">ERROR</span> occurs</span>
                            }
                            control={<Radio color="default" size="small" />}
                        />
                        {state.errorReaction.value !== 'no' && state.errorReaction.value === 'retry' &&
                            <div className="event-retry">
                                <label>
                                    {t(label + 'N-TIMES')}<br />
                                    <input type="number" min={0} value={state.numberOfRetries.value}
                                        onChange={(e) => { handleChange(e, 'numberOfRetries'); }}
                                    />
                                </label>
                                <label>
                                    {t(label + 'DURATION')}<br />
                                    <input type="number" min={0} value={state.retryDuration.value}
                                        onChange={(e) => { handleChange(e, 'retryDuration'); }}
                                    />
                                    <span>{t(label + 'MS')}</span>
                                </label>
                            </div>
                        }
                    </div>

                </RadioGroup>
            }


        </>
    );
}
export default EventConfiguration;
